import React from "react";
import "./Experience.css";
import "aos/dist/aos.css"; // You can also use <link> for styles
import { useTranslation } from "react-i18next";
import i18n from "../../languages/i18n";
import ExperienceCard from "./ExperienceCard";

const Experience = () => {
  const front_Details = [
    { id: 0, title: "HTML", level: "Experienced" },
    { id: 1, title: "CSS", level: "Experienced" },
    { id: 2, title: "JavaScript", level: "Experienced" },
    { id: 3, title: "ReactJS", level: "Experienced" },
    { id: 4, title: "React-native", level: "Experienced" },
    { id: 5, title: "BootStrap", level: "Intermediate" },
  ];
  const backend_Details = [
    { id: 0, title: "Node.js", level: "Experienced" },
    { id: 1, title: "PHP", level: "Experienced" },
    { id: 2, title: "MySql", level: "Experienced" },
    { id: 3, title: "ASP.Net", level: "Intermediate" },
    { id: 4, title: "C#", level: "Experienced" },
    { id: 5, title: "JAVA", level: "Intermediate" },
  ];
  const trainer_Details = [
    { id: 0, title: "In Tunisia", level: "@Education" },
    { id: 1, title: "In Saudi Arabia", level: "@TVTC" },
    { id: 2, title: "Software", level: "Experienced" },
    { id: 3, title: "Hardware", level: "Experienced" },
    { id: 4, title: "Networks", level: "Experienced" },
    { id: 5, title: "Programming", level: "Experienced" },
  ];
  const { t } = useTranslation();
  return (
    <section id="experience">
      <h5 className={i18n.language == "ar" && "arabicText"}>
        {t("experienceSection.what_skills")}
      </h5>
      <h2 className={i18n.language == "ar" && "arabicText"}>
        {t("experienceSection.my_experience_title")}
      </h2>
      <div className="container experience_container">
        <ExperienceCard
          cardTitle={"Frontend development"}
          details={front_Details}
        />
        <ExperienceCard
          cardTitle={"Backend development"}
          details={backend_Details}
        />
        <ExperienceCard cardTitle={"Training"} details={trainer_Details} />
      </div>
    </section>
  );
};

export default Experience;
